import { createTheme } from '@mui/material';

export const MuiThemeConfig = createTheme({
  palette: {
    input: {
      main: '#645AFF',
      darker: '#5950DF',
    },
    error: {
      main: '#D72C0D',
    },
    dark: {
      main: '#5C5F62',
      darker: '#645AFF',
    },
  },
});
